import { CheckCircle, XCircle } from "lucide-react";

// ── Shared UI primitives used across game components ─────────────────────────

export function ProgressBar({ value, max, color, tv }) {
  return (
    <div style={{
      height: tv ? "0.85rem" : "0.65rem", background: "#111", borderRadius: "9999px",
      overflow: "hidden", maxWidth: tv ? "560px" : "100%", margin: "0 auto 0.65rem",
      border: "1.5px solid #000",
    }}>
      <div style={{
        height: "100%", background: color,
        width: `${(value / Math.max(max, 1)) * 100}%`,
        transition: "width 0.4s", borderRadius: "9999px",
      }} />
    </div>
  );
}

export function Spinner({ color, tv }) {
  return (
    <div className="text-center">
      <div style={{
        width: tv ? "5rem" : "3.5rem", height: tv ? "5rem" : "3.5rem",
        border: `4px solid ${color}`, borderTopColor: "transparent",
        borderRadius: "9999px", animation: "spin-h 0.8s linear infinite",
        margin: "0 auto 0.9rem",
      }} />
      <div className="font-heading text-[#aaa]" style={{ fontSize: tv ? "1.5rem" : "1rem" }}>Загрузка...</div>
      <style>{`@keyframes spin-h{from{transform:rotate(0)}to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

export function GuessFeed({ guesses, tv }) {
  return (
    <div style={{ width: tv ? "24rem" : "18rem", flexShrink: 0 }}>
      <h3 className="font-heading text-white mb-2" style={{ fontSize: tv ? "1.5rem" : "1rem" }}>Попытки:</h3>
      <div style={{
        background: "#0a001e", border: "3px solid #000", borderRadius: "1rem",
        boxShadow: "4px 4px 0 #000", padding: "0.8rem",
        maxHeight: tv ? "460px" : "240px", overflowY: "auto",
      }}>
        {!guesses.length
          ? <div className="font-body text-[#333] text-center" style={{ fontSize: "0.85rem" }}>Пока тихо...</div>
          : <div className="space-y-1.5">
            {[...guesses].reverse().map((g, i) => (
              <div key={i} style={{
                display: "flex", alignItems: "center", gap: "0.4rem",
                padding: "0.35rem 0.5rem", borderRadius: "0.6rem",
                background: g.correct ? "rgba(61,255,61,0.15)" : "rgba(255,51,85,0.1)",
              }}>
                {g.correct
                  ? <CheckCircle style={{ color: "#3DFF3D", width: tv ? "1.35rem" : "1rem", height: tv ? "1.35rem" : "1rem", flexShrink: 0 }} />
                  : <XCircle style={{ color: "#FF3355", width: tv ? "1.35rem" : "1rem", height: tv ? "1.35rem" : "1rem", flexShrink: 0 }} />}
                <span className="font-heading" style={{ fontSize: tv ? "0.95rem" : "0.75rem", color: g.correct ? "#3DFF3D" : "#ccc" }}>{g.player}:</span>
                <span className="font-body" style={{ fontSize: tv ? "0.95rem" : "0.75rem", color: g.correct ? "#3DFF3D" : "#888" }}>{g.correct ? "Угадал! 🎉" : "***"}</span>
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  );
}

// Option colors and labels shared between host and player quiz components
export const OPTS = {
  colors: ["#ff3355", "#00aaff", "#3dffa0", "#ffe600"],
  labels: ["A", "B", "C", "D"],
};